import React from "react";
import { Col, Container, Row, Table } from "react-bootstrap";
import { redirect, useLoaderData } from "react-router";
import { getTeamRatings } from "../../lib/api";
import { IAPIResponse, ITeamRating } from "../../types/api";
import { store } from "../..";
import { AUTH_LEVELS } from "../../lib/globals";

export const loader = async ({ params }: any) => {
    const { teamId } = params;
    const user = store.getState().auth.user;

    if (!user || !AUTH_LEVELS.tourneymanagement.includes(user?.userLevel)) {
        return redirect(`/coachs-clubhouse/team/${teamId}`);
    }

    return {
        teamId,
        ratings: await getTeamRatings(params.teamId),
    };
};

const Ratings = (): React.JSX.Element => {
    const { ratings } = useLoaderData() as {
        teamId: string;
        ratings: IAPIResponse & {
            ratings: ITeamRating[];
        };
    };

    const calculateRating = (type: string) => {
        const total = ratings.ratings.reduce(
            (acc, r) => acc + (r.ratings[type as keyof typeof r.ratings] || 0),
            0,
        );

        const count = ratings.ratings.reduce(
            (acc, r) =>
                acc +
                (r.ratings[type as keyof typeof r.ratings] !== undefined &&
                r.ratings[type as keyof typeof r.ratings] !== null
                    ? 1
                    : 0),
            0,
        );

        return count > 0 ? (total / count).toFixed(3) : "N/A";
    };

    return (
        <div data-testid="ratingsContent">
            <Container fluid="xs">
                <Row>
                    <Col>
                        <h2>Current Year Ratings</h2>
                        <Table className="currentYearOverallRatings" striped>
                            <tbody>
                                <tr>
                                    <td width={"50%"}>Head Coaching:</td>
                                    <td>{calculateRating("headCoach")}</td>
                                </tr>
                                <tr>
                                    <td width={"50%"}>Asst. Coaching:</td>
                                    <td>{calculateRating("asstCoach")}</td>
                                </tr>
                                <tr>
                                    <td width={"50%"}>Spectators:</td>
                                    <td>{calculateRating("spectators")}</td>
                                </tr>
                                <tr>
                                    <td width={"50%"}>Overall:</td>
                                    <td>{calculateRating("overall")}</td>
                                </tr>
                            </tbody>
                        </Table>

                        <h2>Individual Ratings</h2>
                        <Table className="currentYearIndividualRatings" striped>
                            <thead>
                                <tr>
                                    <th>Umpire</th>
                                    <th>Head Coaching</th>
                                    <th>Asst. Coaching</th>
                                    <th>Spectators</th>
                                    <th>Overall</th>
                                </tr>
                            </thead>
                            <tbody>
                                {ratings.ratings.map(r => (
                                    <tr key={r.id}>
                                        <td>{r.ratedBy.name}</td>
                                        <td>{r.ratings.headCoach}</td>
                                        <td>{r.ratings.asstCoach}</td>
                                        <td>{r.ratings.spectators}</td>
                                        <td>{r.ratings.overall}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </Table>
                    </Col>
                </Row>
            </Container>
        </div>
    );
};

export default Ratings;
